import { styled } from '@mui/material'
import BaseArrowBackIcon from '@mui/icons-material/ArrowBackIos'

export const ArrowBackIcon = styled(BaseArrowBackIcon)({
  position: 'relative',
  left: 4,
})
